exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".integrations-icon-1{fill:none}.integrations-icon-2{fill:#faedb1}.integrations-icon-3{fill:#bfe7e3}.integrations-icon-4{fill:#1e4e69}.integrations-icon-5{fill:#a6b1b9}\n", ""]);
